import { setClassIf } from '@/scripts/utils/base';
import SearchForm from './SearchForm';
import SearchList from './SearchList';

export default class Search {
   /** 
    * @param {HTMLElement} root
    * @param {{ searchForm: SearchForm, searchList: SearchList }} 
    */
   constructor(root, { searchForm, searchList, minQuery = 3 }) {
      this.$root = root;
      this.searchForm = searchForm;
      this.searchList = searchList;
      this._minQuery = minQuery;

      this._init();
   }

   _init() {
      this._getElements();
      this.searchList.init();
      this._initEvents();
      this._update();
   }

   restart(query, page) {
      this.searchList.clear();
      this.searchList.page = page;
      this.searchForm.query = query;
   }

   _initEvents() {
      this.searchForm.events.addListener('change', () => {
         this.searchList.clear();
         this._update();
      });

      this.searchList.events.addListenerOnce('request.processed', () => {
         this._updateJsonLd();
      });
   }

   _update() {
      const query = this.searchList.query = this.searchForm.query;
      const toShort = query.length < this._minQuery;

      if (!toShort) {
         this.searchList.update();
      } else {
         this.searchList.setMode('loading');
      }

      setClassIf(this.$root, 'search__empty', toShort);
   }

   _updateMeta() {

   }

   _updateJsonLd() {
      this.$jsonLd.innerHTML = JSON.stringify({
         '@context': 'https://schema.org',
         '@type': 'ItemList',
         itemListElement: this.searchList.pageItems.map(({ slug }, i) => ({
            '@type': 'ListItem',
            position: i + 1,
            url: `${process.env.SSR}/posts/${slug}`,
         })),
      });
   }

   _getElements() {
      this.$jsonLd = document.querySelector('.json-ld--search-results');
   }
}